import axios from '@axios'

export default {
  namespaced: true,
  state: {
    countAlertActive: 0,
  },
  getters: {},
  mutations: {
    SET_COUNT_ALERT_ACTIVE(state, count) {
      state.countAlertActive = count
    },
  },
  actions: {
    fetchAlerts(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/alert-histories', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deactivateAlert(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/alert-histories/deactivate/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    exportAlert(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/alert-histories/export', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    countAlertActive(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get('/alert-histories/active-alerts', { params: { id } })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchAlertsByDevice(ctx, { id, dataKey }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`alert-histories/device/${id}`, {
            params: {
              dataKey,
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
